if (!customElements.get('media-carousel-tabs')) {
  class MediaCarouselTabs extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this._relocateTabs();
      this.addEventListener('tabs:change', this._onTabsChange.bind(this), { signal: this.controller.signal });
      this._activatePanel(this._activeTab()?.getAttribute('aria-controls'));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    _relocateTabs() {
      const tablist = this.querySelector('.media-carousel-tabs__pills');
      if (!tablist) return;

      [...this.querySelectorAll('[data-cc-tab]')].forEach((tab, index) => {
        tablist.appendChild(tab);
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      });
    }

    _activeTab() {
      return this.querySelector('.media-carousel-tabs__pills [data-cc-tab]');
    }

    _onTabsChange(event) {
      this._activatePanel(event.detail?.panelId);
    }

    _activatePanel(panelId) {
      if (!panelId) return;

      const panel = this.querySelector(`#${panelId}`);
      const slider = panel?.querySelector('theme-slider');
      if (!slider) return;

      requestAnimationFrame(() => {
        if (typeof slider.setUpSlider === 'function') slider.setUpSlider();
      });

      this.querySelectorAll('.media-carousel-tabs__nav').forEach((navArrows) => {
        if (typeof navArrows.setTarget === 'function') navArrows.setTarget(slider.id);
      });
    }
  }

  customElements.define('media-carousel-tabs', MediaCarouselTabs);
}
